<template>
  <div class="file-wrap">
    <div class="file-row">
      <div class="file-type">
        <i class="fa fa-file " />
      </div>
      <div class="file-name">
        {{ file.basename }} ({{ fileSize }})
      </div>
      <div class="file-btns">
        <span v-if="file.url" class="file-btn file-btn__url" @click="urlShown = !urlShown">
          <i class="fa fa-link" />
        </span>
        <span ref="deleteBtn" class="file-btn file-btn__delete" @click="deleteFile">
          <i class="fa fa-times" />
        </span>

        <div v-if="file.url" class="file-link-tooltip" :class="{ opened: urlShown }">
          {{ file.url }}
          <div class="file-link-tooltip__close-wrap">
            <button class="file-btn file-link-tooltip__close" @click="urlShown = !urlShown">
              <i class="fa fa-times" aria-hidden="true" />
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    file: {
      type: Object,
      default: () => ({}),
    },
  },

  data: () => ({
    urlShown: false,
  }),

  computed: {
    fileSize() {
      const { size } = this.file;
      if (!size) {
        return 0;
      }
      if (size > 1024 * 1024) {
        return `${(size / (1024 * 1024)).toFixed(2)}Mb`;
      }
      if (size > 1024) {
        return `${(size / 1024).toFixed(2)}Kb`;
      }
      return `${size.toFixed(2)}B`;
    },
  },

  methods: {
    deleteFile() {
      if (window.confirm(`Do you really want to delete file ${this.file.path}`)) {
        $(this.$refs.deleteBtn).find('i').removeClass('fa-times').addClass('fa-refresh rotating');
        this.$apiHttp.post(`${this.$config.app_api.prefix}selectel/delete`, { path: this.file.path })
          .then(() => {
            this.$emit('fileDeleted', this.file);
            this.$store.commit('notifications/setSuccessNotification', 'Deleted.');
          })
          .catch((error) => {
            $(this.$refs.deleteBtn).find('i').addClass('fa-times').removeClass('fa-refresh rotating');
            this.$store.dispatch('notifications/setHttpError', { error, text: 'Error in deleting file request' });
            console.error(error);
          });
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// File.vue?5feb3a02